module.exports = __webpack_public_path__ + "static/media/8795.ed263229.png";